import { useTranslation } from 'react-i18next'
import { LoadingState } from '@asad/crane-ui'

/** Ekran ładowania odczepionego okna mapy — ten sam dla chunku trasy, bootstrapu profilu
 *  i oczekiwania na dane z kanału. Bez tego jedno otwarcie okna pokazuje trzy różne
 *  spinnery pod rząd, a dwa pierwsze pochodzą z legacy powłoki. */
export const DetachedMapLoading = () => {
  const { t } = useTranslation()

  return (
    <div className='crane-ui-surface flex min-h-screen w-full items-center justify-center bg-crane-background p-4 text-crane-foreground'>
      <div className='w-full max-w-crane-card rounded-crane-md bg-crane-card shadow-crane-soft'>
        <LoadingState label={t('main.detachedLoading')} className='py-10 text-crane-base' />
      </div>
    </div>
  )
}
